import { CountryIso3Code, CurrencyCode } from '@domgen/dgx-fe-i18n';
import { CustomerDetails } from '../customer/customer-details.interface';
import { RegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.interface';
import { RegistrationChannel } from './registration-channel.enum';
import { RegistrationSystemCode } from './registration-system-code.enum';

export interface RegistrationRequest {
  channel: RegistrationChannel.Web;
  client: string;
  country: CountryIso3Code.UnitedStates;
  currency: CurrencyCode.USDollar;
  customer: CustomerDetails;
  merchandise: RegistrationApplianceDetails[];
  system: RegistrationSystemCode;
}
